var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wid-100"},[_c('collect')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }